// extracted by mini-css-extract-plugin
module.exports = {"somethingWrongContainer":"src-App__somethingWrongContainer--15gon","app":"src-App__app--2iKXm"};